import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { authenticatedUserStore } from 'src/stores'
import Crumbs from 'src/components/Crumbs'
import GlobalAdminForm from 'src/components/Forms/GlobalAdminForm'
import UnauthorizedPage from 'src/routes/UnauthorizedPage'

class GlobalAdminRoute extends Component {
    componentDidMount() {
        this.getAppPermissions()
        // start polling to avoid the user to further submit global admin request once the permission is deprived
        this.interval = setInterval(this.getAppPermissions, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    getAppPermissions = () => {
        authenticatedUserStore.getAppPermissions(
            authenticatedUserStore.username,
            null
        )
    }

    render() {
        const { routeProps } = this.props
        const canGlobalAdmin = authenticatedUserStore.canGlobalAdmin
        // to avoid unauthorized page flashing briefly once the user refreshes the page
        if (canGlobalAdmin === null) {
            return null
        }
        if (canGlobalAdmin) {
            return (
                <>
                    <Crumbs
                        breadcrumbs={[
                            {
                                label: 'Users',
                                path: '/users',
                            },
                            {
                                label: 'Request global admin access',
                            },
                        ]}
                        path={'/global-admins/request'}
                        {...routeProps}
                    />
                    <GlobalAdminForm
                        userData={authenticatedUserStore.userData}
                        {...routeProps}
                    />
                </>
            )
        } else {
            clearInterval(this.interval)
            return (
                <UnauthorizedPage
                    noHeader={true}
                    warningText={
                        'You are not authorized to request global admin access.'
                    }
                />
            )
        }
    }
}

export default observer(GlobalAdminRoute)
